import * as React from "react";
import { DateTime } from "luxon";
import { Icon } from "../externals";
import "./FileTableRow.scss";
import { useRef } from "react";
const FileTableRow = ({ type, name, size, lastModifiedDate, isClicked, onClick, onDoubleClick, setHeight, }) => {
    let className = isClicked ? "filetablerow-clicked" : "filetablerow";
    let sizeBytes = type === "DIRECTORY" ? "" : formatBytes(size);
    let iconName;
    const rowRef = useRef(null);
    React.useEffect(() => {
        if ((rowRef === null || rowRef === void 0 ? void 0 : rowRef.current) && isClicked) {
            setHeight(rowRef.current.offsetHeight);
        }
    }, [rowRef]);
    switch (type) {
        case "DIRECTORY":
            iconName = "folder-close";
            break;
        case "FILE":
            iconName = "document";
            break;
        default:
            iconName = "";
    }
    const date = typeof lastModifiedDate !== "undefined"
        ? DateTime.fromMillis(lastModifiedDate)
            .toUTC()
            .toFormat("dd/MM/yyyy HH:mm")
        : "";
    if (typeof onDoubleClick !== "undefined") {
        return (React.createElement("div", { role: "filetable-row-container", className: className, ref: rowRef, onClick: () => {
                onClick();
            }, onDoubleClick: () => {
                onDoubleClick();
            } },
            React.createElement("div", { role: iconName, className: "filetablerow-cell-icon" },
                React.createElement(Icon, { icon: iconName, size: 16 })),
            React.createElement("div", { className: "filetablerow-cell-name", role: "cell" }, name),
            React.createElement("div", { className: "filetablerow-cell-size", role: "cell" }, sizeBytes),
            React.createElement("div", { className: "filetablerow-cell-date", role: "cell" }, date)));
    }
    else {
        return (React.createElement("div", { role: "filetable-row-container", className: className, onClick: () => {
                onClick();
            }, ref: rowRef },
            React.createElement("div", { role: iconName, className: "filetablerow-cell-icon" },
                React.createElement(Icon, { icon: iconName, size: 16 })),
            React.createElement("div", { className: "filetablerow-cell-name", role: "cell" }, name),
            React.createElement("div", { className: "filetablerow-cell-size", role: "cell" }, sizeBytes),
            React.createElement("div", { className: "filetablerow-cell-date", role: "cell" }, date)));
    }
};
export function formatBytes(size) {
    if (size === 0) {
        return "0 B";
    }
    const sizes = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const newSize = parseFloat((size / Math.pow(1024, i)).toFixed(3));
    return newSize + " " + sizes[i];
}
export default FileTableRow;
//# sourceMappingURL=FileTableRow.js.map